import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/themes/vestiaire.css";
import "@/themes/mode.css";
import "@/themes/da.css";
import App from "@/App";
import { initMode } from "@/lib/mode";
import { initAppearance } from "@/lib/appearance";

initMode();
initAppearance();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
